import React, { memo } from 'react';
import styles from './StepIndicator.module.scss';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps?: number;
}

/**
 * Reusable step indicator for multi-step dialogs
 */
const StepIndicator: React.FC<StepIndicatorProps> = memo(({ currentStep, totalSteps = 2 }) => {
  return (
    <div
      className={styles.stepIndicator}
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={1}
      aria-valuemax={totalSteps}
    >
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep >= stepNumber;
        const isCompleted = currentStep > stepNumber;

        return (
          <React.Fragment key={stepNumber}>
            <div
              className={`${styles.step} ${isActive ? styles.active : ''} ${isCompleted ? styles.completed : ''}`}
              aria-current={currentStep === stepNumber ? 'step' : undefined}
            >
              {stepNumber}
            </div>
            {stepNumber < totalSteps && (
              <div
                className={`${styles.stepLine} ${currentStep > stepNumber ? styles.active : ''}`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
});

StepIndicator.displayName = 'StepIndicator';

export default StepIndicator;
